<div class="flex-column flex-fill">
  <div class="stg-cfg-items-header">Items</div>
  <ag-grid-angular
    #agGridFF
    class="ag-theme-balham"
    style="height: 100%;"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"

    [suppressMoveWhenRowDragging]="true"
    [animateRows]="true">
  </ag-grid-angular>
</div>